export default "__VITE_ASSET__CvEpjPGg__"